import { Box, Checkbox, Typography } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { addOrderData } from '../../../../../services/ApiService'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'
import { RequestType } from '../../SingleRequest/types/Request.type'

interface NewHasDuplicatesProps {
  request: RequestType
}

const NewHasDuplicates: React.FC<NewHasDuplicatesProps> = ({ request }) => {
  const invalidate = useInvalidateQueries()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['set-has-duplicate'],
    mutationFn: () =>
      addOrderData({
        orderId: request.id,
        hasDuplicates: !request.hasDuplicates,
      }),
    onSuccess: (data: any) => {
      newRequestDrawerStore.updateRequest(data)
      invalidate(['requests-table'])
    },
  })

  const onChange = async () => {
    if (isPending) return
    await mutateAsync()
  }

  return (
    // @ts-ignore
    <CustomAccordion summary={'Повторное обращение'}>
      <Box
        className={'fx-nowrap aln-center'}
        sx={{ cursor: 'pointer' }}
        onClick={onChange}
      >
        <Checkbox checked={request.hasDuplicates} />
        <Typography variant={'subtitle1'}>
          Отметить как повторное обращение
        </Typography>
      </Box>
    </CustomAccordion>
  )
}

export default observer(NewHasDuplicates)
